import {
  Backend,
  getQueryParamValue,
  OrderByDirection,
} from '@freelancer/datastore/core';
import { isDefined } from '@freelancer/utils';
import { PaymentShareMembersCollection } from './payment-share-members.types';

export function paymentShareMembersBackend(): Backend<PaymentShareMembersCollection> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.ASC,
    },
    fetch: (authUid, ids, query) => ({
      endpoint: 'users/0.1/payment_sharing/members',
      isGaf: false,
      params: {
        payment_share_team_id: getQueryParamValue(
          query,
          'paymentShareTeamId',
        )[0],
        virtual_billing_agreement_id: getQueryParamValue(
          query,
          'billingAgreementId',
        )[0],
        member_entity_id: getQueryParamValue(query, 'entityId')[0],
        member_entity_type: getQueryParamValue(query, 'entityType')[0],
        status: getQueryParamValue(query, 'status')[0],
      },
    }),
    push: (authUid, member) => {
      const payload = {
        members: [
          {
            payment_share_team_id: member.paymentShareTeamId,
            entity_id: member.entityId,
            entity_type: member.entityType,
            status: member.status,
            use_team_spend_limit: member.useTeamSpendLimit,
            is_spending_limit_active: member.isSpendingLimitActive,
            spending_limit_duration: member.spendingLimitDuration,
            spending_limit_amount: member.spendingLimitAmount,
          },
        ],
      };

      return {
        endpoint: 'users/0.1/payment_sharing/members',
        payload,
      };
    },
    set: undefined,
    update: (authUid, delta, originalDocument) => {
      if (!delta.status) {
        throw new Error(`Missing status in member update`);
      }

      if (
        !isDefined(delta.useTeamSpendLimit) ||
        !isDefined(delta.isSpendingLimitActive) ||
        !isDefined(delta.spendingLimitDuration) ||
        !isDefined(delta.spendingLimitAmount)
      ) {
        throw new Error(`Missing individual spend limit in member update`);
      }
      const payload = {
        members: [
          {
            id: originalDocument.id,
            payment_share_team_id: originalDocument.paymentShareTeamId,
            entity_id: originalDocument.entityId,
            entity_type: originalDocument.entityType,
            status: delta.status,
            use_team_spend_limit: delta.useTeamSpendLimit,
            is_spending_limit_active: delta.isSpendingLimitActive,
            spending_limit_duration: delta.spendingLimitDuration,
            spending_limit_amount: delta.spendingLimitAmount,
          },
        ],
      };

      return {
        endpoint: 'users/0.1/payment_sharing/members',
        method: 'PUT',
        payload,
      };
    },

    remove: undefined,
  };
}
